<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.9724 13.6748C20.6045 13.075 21 12.2223 21 11.2777C21 9.47035 19.5456 8 17.7579 8H17.5786C15.2573 8 13.0481 10.7925 11.9999 12.34C10.9519 10.7925 8.74268 8 6.4214 8H6.24215C4.45438 8 3 9.47035 3 11.2777C3 12.2223 3.39546 13.075 4.0276 13.6748C3.39546 14.2745 3 15.1272 3 16.0718C3 17.879 4.45438 19.3494 6.24215 19.3494H6.4214C8.74268 19.3494 10.9519 16.5569 11.9999 15.0096C13.0481 16.5569 15.2573 19.3494 17.5786 19.3494H17.7579C19.5456 19.3494 21 17.879 21 16.0718C21 15.1272 20.6045 14.2745 19.9724 13.6748ZM19.1928 16.0381C19.1928 16.8673 18.5245 17.5421 17.703 17.5421H17.5234C16.1154 17.5421 14.1989 15.3084 13.1205 13.6385C14.1989 11.9688 16.1154 9.73488 17.5234 9.73488H17.703C18.5245 9.73488 19.1928 10.4095 19.1928 11.2389C19.1928 12.1409 18.5714 12.9481 17.703 12.9481V14.3289C18.5714 14.3289 19.1928 15.136 19.1928 16.0381ZM6.29694 17.5421H6.47661C7.88454 17.5421 9.80106 15.3084 10.8795 13.6385C9.80106 11.9688 7.88454 9.73488 6.47661 9.73488H6.29694C5.47553 9.73488 4.80723 10.4095 4.80723 11.2389C4.80723 12.1409 5.42858 12.9481 6.29694 12.9481V14.3289C5.42858 14.3289 4.80723 15.136 4.80723 16.0381C4.80723 16.8673 5.47553 17.5421 6.29694 17.5421Z"
      fill="#4B4C52"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C22.6569 5 24 6.34315 24 8V20C24 21.6569 22.6569 23 21 23H3C1.34315 23 0 21.6569 0 20V8C0 6.34315 1.34315 5 3 5H7ZM9 5V3H15V5H9ZM3 7C2.44772 7 2 7.44772 2 8V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V8C22 7.44772 21.5523 7 21 7H3Z"
      fill="#4B4C52"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'JobsIconOutline',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
